import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary/Index.jsx";
import { config } from "./config/index.js";
import { ChakraProvider } from "@chakra-ui/react";

window.logBackup = console.log;
console.info("Application is running in " + config.MODE + " mode");

const proxy = new Proxy(
  {
    DEBUG_MODE: config.MODE === "development",
  },
  {
    set: (target, prop, value) => {
      target[prop] = value;
      if (target["DEBUG_MODE"]) {
        console.log = window.logBackup;
      } else {
        console.log = () => {};
      }
    },
  }
);

window.applicationProxy = proxy;

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <BrowserRouter>
    <ErrorBoundary>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </ErrorBoundary>
  </BrowserRouter>
  // </React.StrictMode>
);
